import styled from 'styled-components';
import { Button as ButtonAntd } from 'antd';

export const BtnSuccess = styled(ButtonAntd)`
  color: #fff;
  background: #24a95d;
  border: none;
  font-size: 16px;
  line-height: 19px;
  border-radius: none;
  &:hover {
    background: #24a95d;
    color: #fff;
  }
  &:focus {
    background-color: #24a95d;
    color: #fff;
  }

`;

export const BtnSuccessOutline = styled(ButtonAntd)`
  &,
  &:focus {
    background: transparent;
    color: #0d364a;
    border-color: #0d364a;
    border-width: 2px;
  }
  &:hover,
  &:active {
    color: #0d364a;
    border-color: #0d364a;
  }
`;

export const BtnLink = styled(ButtonAntd)`
  &,
  &:focus {
    color: ${props => (props.black ? 'rgba(0, 0, 0, 0.85)' : '#24A95D')};
  }

  &:hover,
  &:active {
    color: ${props => (props.black ? 'rgba(0, 0, 0, 1)' : '#24A95D')};
  }
`;
export const BtnLinkBack = styled(ButtonAntd)`
  padding: 15px 0px;

  &,
  &:focus {
    color: ${props => (props.black ? 'rgba(0, 0, 0, 0.85)' : '#24A95D')};
  }

  &:hover,
  &:active {
    color: ${props => (props.black ? 'rgba(0, 0, 0, 1)' : '#24A95D')};
  }
`;
